import React from 'react';
import { Col } from 'reactstrap';
import PropTypes from 'prop-types';

const stripHtml = (html) => new DOMParser().parseFromString(html, 'text/html').body.textContent || '';

const ViewCard = ({ headerIcon, headerContent, bodyContent, children, onClick, paddingBox = 'padding_box' }) => (
  <Col xs={12} sm={6} md={6} lg={4}>
    <div className="border_box" onClick={onClick}>
      <div className="border_box_title font-weight-bold d-flex align-items-center">
        {headerIcon && <img src={headerIcon} alt="Header Icon" width="30" />}
        <span className="ml-1">{stripHtml(headerContent)}</span>
      </div>
      <div className={paddingBox}>
        <div className="view_question_height view_questionhtml margin_bottom_40 cfa_notes_view">
          {stripHtml(bodyContent)}
        </div>
        {children}
      </div>
    </div>
  </Col>
);


ViewCard.propTypes = {
  headerIcon: PropTypes.string,
  headerContent: PropTypes.string.isRequired,
  bodyContent: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
  paddingBox: PropTypes.string
};

export default ViewCard;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/ViewCard.jsx